import type { DeepReadonly } from "@itandi/itandi-bb-ui";
import {
	Breadcrumbs,
	Button,
	Panel,
	PanelBody,
	PanelHeader
} from "@itandi/itandi-bb-ui";
import Link from "next/link";
import type React from "react";
import { useState } from "react";
import { VendorSettingLayout } from "~/components/common/layouts/settings/VendorSettingLayout";
import { VendorLayoutV2 } from "~/components/common/layouts/VendorLayoutV2";
import { VendorPartnerAddModal } from "~/components/specifics/vendors/settings/vendor_partners/VendorPartnerAddModal";
import { VendorPartnerList } from "~/components/specifics/vendors/settings/vendor_partners/VendorPartnerList";
import type { VendorPartner } from "~/models/VendorPartner";
import { PATH } from "~/pages/vendors/settings";
import SettingStyles from "../SettingStyle.module.scss";

type Props = DeepReadonly<{
	vendorPartners: VendorPartner[];
}>;

export const Page: React.FC<Props> = ({ vendorPartners }: Props) => {
	const [isModalOpen, setIsModalOpen] = useState(false);

	return (
		<VendorLayoutV2>
			<VendorSettingLayout>
				<div className={SettingStyles.SpBreadcrumbsWrapper}>
					<Breadcrumbs
						items={[
							{ as: Link, href: PATH, label: "設定一覧" },
							{ label: "協力会社" }
						]}
					/>
				</div>
				<Panel>
					<PanelHeader
						rightArea={
							<Button
								onClick={() => {
									setIsModalOpen(true);
								}}
								variant="primary"
							>
								追加
							</Button>
						}
						title="協力会社"
					/>
					<PanelBody>
						<VendorPartnerList vendorPartners={vendorPartners} />
					</PanelBody>
				</Panel>
				{isModalOpen ? (
					<VendorPartnerAddModal
						handleClose={() => {
							setIsModalOpen(false);
						}}
					/>
				) : null}
			</VendorSettingLayout>
		</VendorLayoutV2>
	);
};
